import React, { useEffect, useState } from "react";
import "./featured.css";
import { Btn, trimText } from "../../utils/utils";
import FeatureCards from "./FeatureCards";
import { AxiosGet } from "../../api/api";
import Loading from "../ui/Loading";
import { useNavigate } from "react-router-dom";
import SearchFilter from "../../components/search-filter/SearchFilter";
import useFilterData from "../../hooks/useFilterData";
import Pagination from "../../utils/pagination";
import EmptyComp from "../ui/EmptyComp";
import HouseCard from "../ui/HouseCard";

const Featured = () => {
  const [propData, setPropData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isBLoading, setIsBLoading] = useState(false);
  const { data } = useFilterData();
  const { propType } = useFilterData();
  const { propUse } = useFilterData();
  const [curPage, setCurPage] = useState(1);
  const [pag, setPag] = useState();

  const { activeProp } = useFilterData();
  const btnArr = ["Residential", "Commercial"];
  const navigate = useNavigate();

  const [active, setActive] = useState("Residential");

  const clickBtn = (item) => {
    setActive(item);
  };

  const searchPropUrl = `developers/properties/?propertyType=${propType}&propertyUse=${propUse}&location=${data?.location}&minPrice=${data?.minPrice}&maxPrice=${data?.maxPrice}&page=${curPage}&page_size=${12}`;
  const propUrl = `developers/properties/?propertyUse=${active}&page=${curPage}&page_size=${12}`;

  const getSearchedData = () => {
    setIsLoading(true);
    setIsBLoading(true);
    AxiosGet(searchPropUrl)
      .then((res) => {
        // console.log(res);
        setPropData(res.data);
        setPag(res.pagination);
        setIsLoading(false);
        setIsBLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
        setIsBLoading(false);
      });
  };

  const getRes = () => {
    setIsLoading(true);
    AxiosGet(propUrl)
      .then((res) => {
        // console.log(res);
        setPropData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };
  const getComm = () => {
    setIsLoading(true);
    AxiosGet(propUrl)
      .then((res) => {
        // console.log(res);
        setPropData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  const clickNext = () => {
    setCurPage(pag?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pag?.previousPage);
  };
  const viewProp = (item) => {
    localStorage.setItem('property', JSON.stringify(item));
    navigate(`/dev-view/${item?.id}`)
  };

  useEffect(() => {
    if (active === "Residential") {
      getRes();
    }
    if (active === "Commercial") {
      getComm();
    }
    // eslint-disable-next-line
  }, [active]);

  const clickHouse = (item) => {
    localStorage.setItem("property", JSON.stringify(item));
    navigate(`/house-view/${item?.id}`);
  };

  return (
    <div className="featured" style={{marginBottom: 40}}>
      <div className="home_filter">
        <SearchFilter btnClick={getSearchedData} loading={isBLoading} />
      </div>
      <div className="featured-head">
        <h2>
          Feat<span>ured</span> Pro<span>perties</span>
        </h2>
        <p>
          At <span>Prime property</span> we simplify your property search with a
          seamless, user-friendly experience.
        </p>
        <div className="featured-btn">
          <div className="featured-btn_left">
            {btnArr.map((item, i) => {
              return (
                <Btn
                  btnClass={active === item ? "home-btn_s" : "home-btn_trans-s"}
                  btnClick={() => clickBtn(item)}
                  btnText={item}
                  key={i}
                />
              );
            })}
          </div>
          <div className="featured-btn_right">
            <Btn
              btnClass={"home-btn_trans-s"}
              btnLink={"/residential"}
              btnText={"See all"}
            />
          </div>
        </div>
      </div>
      {isLoading && <Loading />}
      {isLoading && propData?.length <= 0 && (
        <EmptyComp text={"Nothing to show here."} />
      )}
      <div className="featured-cards_cont">
        {!isLoading &&
          propData?.map((item, i) => {
            return (
              <HouseCard
                key={i}
                tag={item?.isVerified}
                price={`#${item?.pricePerUnit?.toLocaleString()}`}
                add={item.address}
                // bath={item.bath}
                // bed={item.bed}
                propType={item?.propertyType}
                noOfUnits={item?.numberOfUnits}
                title={item?.name}
                btnClick={() => viewProp(item)}
                img={item?.pictures[0]?.link}
                houseStyle={{ width: "20%" }}
              />
            );
          })}
      </div>
      {pag && (
        <Pagination clickNext={clickNext} clickPrev={clickPrev} pagData={pag} />
      )}
    </div>
  );
};

export default Featured;
